const SERVICE_WORKER_PATH = '/threadlineServiceWorker.js'

/**
 * Registers the application service worker, which powers installability, the offline safe
 * application shell and Web Push. Failures are never fatal: the application works without
 * a service worker, only without those extras.
 */
export async function registerApplicationServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return null
  }

  try {
    return await navigator.serviceWorker.register(SERVICE_WORKER_PATH, { scope: '/' })
  } catch (registrationFailure) {
    console.warn('The service worker could not be registered', registrationFailure)
    return null
  }
}
